import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { createBusinessProductSchema } from "../../Helper/validationSchemas";
import { getCategories } from "../../store/actions/investment/getCategories";
import ".//Investment.css";
import BackArrow2 from "../../components/BackArrow2";
import { createBusinessProduct } from "../../store/actions/businesses/createBusinessProduct";
import CreateBusinessProductMain from "../../components/investment/CreateBusinessProductMain";
import { editBusinessProduct } from "../../store/actions/businesses/editBusinessProduct";
import dayjs from "dayjs";
import { getServerDate } from "../../config/dateformatter";

const CreateBusinessProduct = () => {
  const { state } = useLocation();

  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [investmentMemo, setInvestmentMemo] = useState(
    state?.cycle?.investment_memo || null
  );
  const [memoFiles, setMemoFiles] = useState([]);

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    const formData = new FormData();

    if (memoFiles) {
      memoFiles.forEach((document) => {
        if (typeof document !== "string") {
          formData.append("documents[]", document);
        }
      });
    }
    if (state?.business_id) {
      formData.append("business_id", state?.business_id);
    }
    if (values?.investment_category_id?.value) {
      formData.append(
        "investment_category_id",
        values.investment_category_id.value
      );
    }
    formData.append("investment_type", values.investment_type?.value);
    if (values?.investment_type?.name === "Mudarabah") {
      formData.append("roi_range[min_roi]", values.min_roi);
      formData.append("roi_range[max_roi]", values.max_roi);
    }
    if (investmentMemo && typeof investmentMemo !== "string") {
      formData.append("document", investmentMemo);
      formData.append("investment_memo", investmentMemo);
    }

    if (values?.sendNotification) {
      formData.append("send_email", 1);
    }
    if (values.upcoming?.value === "Yes") {
      formData.append("is_upcoming", 1);
    }
    if (values?.performance_incentive_fee) {
      formData.append(
        "performance_incentive_fee",
        values?.performance_incentive_fee
      );
    }
    if (values?.brokerage_fee) {
      formData.append("brokerage_fee", values?.brokerage_fee);
    }

    formData.append("currency", values?.currency?.label);
    formData.append("name", values?.name);
    // formData.append("status", 1);
    // REMOVE IT BY FAAIZ, IT'S NOT ACCOUNTED FOR ON THE BE
    formData.append("minimum_amount", values?.minimum_amount);
    formData.append("amount", values?.amount);
    if (values?.due_date) {
      formData.append("due_date", getServerDate(values?.due_date));
    }
    if (values?.target?.value) {
      formData.append("target", values?.target?.value);
    }
    formData.append("repayment_type", values?.repayment_type?.value);
    // formData.append(
    //   "duration",
    //   `${values?.duration} week${values?.duration == 1 ? "" : "s"}`
    // );
    formData.append("duration", Number(values?.duration));
    formData.append("campaign_duration_type", `weeks`);
    formData.append("roi", values?.roi);
    formData.append("regular_admin_fee", values?.regular_admin_fee);
    formData.append("business_admin_fee", values?.business_admin_fee);
    formData.append("executive_admin_fee", values?.executive_admin_fee);
    formData.append("investment_id", state?.investment_id);

    if (id) {
      dispatch(
        editBusinessProduct({
          payload: formData,
          id,
          setSubmitting,
          cb: () => {
            navigate(-2);
          },
        })
      );
    } else {
      dispatch(
        createBusinessProduct({
          payload: formData,
          navigate,
          failed: () => {
            setSubmitting(false);
          },
        })
      );
    }
  };

  const form = useFormik({
    initialValues: {
      performance_incentive_fee: 0,
      brokerage_fee: 0,
      upcoming: {
        label: "No",
        value: "No",
      },
      currency: "",
      amount: "",
      name: "",
      business_roi: "0",
      regular_roi: "0",

      regular_admin_fee: "0",
      business_admin_fee: "0",
      executive_admin_fee: "0",

      executive_roi: "0",

      repayment_type: "",
      duration: "",
      roi: "0",
    },
    validationSchema: createBusinessProductSchema,

    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (state?.cycle) {
      const {
        amount,
        minimum_amount,
        banner,
        business_admin_fee,
        currency,
        due_date,
        duration,
        executive_admin_fee,
        id,
        investment_id,
        investment_memo,
        name,
        investmentCategory,
        regular_admin_fee,
        repayment_type,

        roi,
      } = state?.cycle;
      form.setValues({
        currency: { label: currency, value: currency },
        amount,
        name,
        minimum_amount,
        regular_admin_fee,
        business_admin_fee,
        executive_admin_fee,
        investment_memo_url: investment_memo,
        investment_category_id: investmentCategory,
        repayment_type: { label: repayment_type, value: repayment_type },
        investment_type: {
          label: state?.cycle?.investment_type,
          value: state?.cycle?.investment_type,
          name: state?.cycle?.investment_type,
        },
        duration,
        roi,
        min_roi: state?.cycle?.roi_range?.min_roi,
        max_roi: state?.cycle?.roi_range?.max_roi,
        due_date: dayjs(due_date),
        target: { label: "Everyone", value: "everyone" },
      });
    }
  }, []);

  return (
    <DashboardLayout>
      <div className="px-2 lg:px-8  ">
        <div className="flex items-center mb-8 flex-row md:items-center">
          <Link to={"/dashboard"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-2" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
          <div
            onClick={() => {
              navigate(-1);
            }}
            className="font-semibold cursor-pointer text-[#475467] text-base flex"
          >
            Business
          </div>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 md:mr-2" />
          <span className="font-semibold text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md md:w-[120px]">
            {id ? "Edit Cycle" : "Create Cycle"}
          </span>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center mt-8 mb-4 md:mb-6">
          <div className=" flex w-full">
            {id ? (
              <h1 className="font-semibold text-xl md:text-2xl">
                Edit {state?.name}
              </h1>
            ) : (
              <h1 className="font-semibold text-xl md:text-2xl">
                Add a Cycle to {state?.name}
              </h1>
            )}
          </div>
        </div>
        <BackArrow2 mb={20} ml={0} />

        <div>
          <CreateBusinessProductMain
            investmentMemo={investmentMemo}
            memoFiles={memoFiles}
            setInvestmentMemo={setInvestmentMemo}
            setMemoFiles={setMemoFiles}
            form={form}
            type={id ? "EDIT" : "CREATE"}
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CreateBusinessProduct;
